import { render, staticRenderFns } from "./UserResetPass.vue?vue&type=template&id=1b6f47db&scoped=true&"
import script from "./UserResetPass.vue?vue&type=script&lang=js&"
export * from "./UserResetPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6f47db",
  null
  
)

export default component.exports